import { Announcement, PagedAnnouncement, PagedResult, Result } from "@models";
import requests from "./agent";

export const announcementService = {
  getAll: async (request: PagedAnnouncement) => {
    const response = await requests.get<Result<PagedResult<Announcement>>>(
      "/api/Announcement/GetAll",
      { params: request }
    );
    return response.result;
  },
};
